// extracted by mini-css-extract-plugin
module.exports = {"root":"SendOrDeleteModal_root__1ku9G","header":"SendOrDeleteModal_header__1RUy1","form":"SendOrDeleteModal_form__NMqk-","buttons":"SendOrDeleteModal_buttons__XOVc_"};